import Image from "next/future/image";

// DPIIT / Startup India recognition credential — single source of truth for
// every placement (footer, about page, homepage trust strip).
//
// Uses the official DPIIT + #startupindia recognition logo supplied by the
// Startup India programme (ITMTB is a recognised startup). The logo carries the
// national emblem + wordmarks, so it sits on a white chip to stay legible on any
// surface (including the dark footer). The recognition number is the extra
// verifiable fact the logo itself does not carry.
const RECOGNITION_NO = "DIPP274362";
const LOGO_SRC = "/dpiit-startupindia.webp";
const LOGO_W = 1969;
const LOGO_H = 655;

export default function DpiitBadge({ variant = "light", bare = false, className = "" }) {
  const logoHeight = variant === "dark" ? "h-7" : "h-9";
  const chrome = bare ? "" : "rounded-lg border border-gray-200 bg-white px-4 py-2.5 shadow-sm";

  return (
    <div
      className={`inline-flex items-center gap-3 ${chrome} ${className}`}
      aria-label={`Recognised by DPIIT under the Startup India initiative, recognition number ${RECOGNITION_NO}`}
    >
      <Image
        src={LOGO_SRC}
        alt="Recognised by DPIIT — Startup India"
        width={LOGO_W}
        height={LOGO_H}
        className={`${logoHeight} w-auto shrink-0`}
      />
      <span className="h-8 w-px bg-gray-200 shrink-0" aria-hidden="true" />
      <div className="leading-tight text-left">
        <p className="text-[10px] font-semibold uppercase tracking-wider text-gray-400">Recognised</p>
        <p className="text-sm font-semibold text-gray-900">Reg. No. {RECOGNITION_NO}</p>
      </div>
    </div>
  );
}
